import React, { createContext, useContext, useReducer } from "react";
import {
  UPDATE_FILTER_CONTRACTS_TOKEN,
  UPDATE_FILTER_CONTRACTS_PAGENUMBER,
  UPDATE_FILTER_CONTRACTS_SORT,
  UPDATE_FILTER_CONTRACTS_OBJECT,
  CLEAR_FILTER_CONTRACTS,
  UPDATE_CONTRACT_DATA,
  UPDATE_CONTRACTS_DATA,
  UPDATE_HOME_CONTRACTS_DATA,
  UPDATE_EVENT_FILE,
  UPDATE_HOLDINGS_FILE,
  UPDATE_RESEARCH_FILE,
  UPDATE_PORTFOLIO,
} from "~/actions/filter_contracts";
import { SortOptionValue } from "~/constants";
import reducer from "../reducers/filter_contracts_reducer";

const today = new Date();
const threeMonthsFromToday = new Date(new Date().setMonth(new Date().getMonth() + 3));

interface FilterContractsContextInt {
  tokensContracts: boolean;
  refreshContract: number;
  refreshContracts: number;
  refreshHomeContracts: number;
  sortContracts: SortOptionValue;
  pageNumberContracts: number;
  filterContracts: {
    // IF WE OPEN  THE WEBPAGE DON'T SEARCH, UNLESS WE USE MARKET
    // initial: true,

    // ALL CONTRACT FILTERS
    // search: "",
    // market: "finance_us",
    active: boolean;
    played: boolean;
    bids: [number, number];
    prize: [number, number];
    dates: [Date, Date];

    // SPECIFIC TO MARKET FILTERS
    contracts: string[];
    param1: string[];
    param2: string[];
    param3: string[];
    param4: string[];

    cparam0: string;
    // param5: [],
  };

  // S3 FILES
  eventFile: string;
  holdingsFile: string;
  researchFile: string;
  eventVerified: boolean;
  holdingsVerified: boolean;
  researchVerified: boolean;
  portfolio: number;
}

const initialState: FilterContractsContextInt = {
  tokensContracts: false,
  refreshContract: 0,
  refreshContracts: 0,
  refreshHomeContracts: 0,
  sortContracts: "oldest-contracts",
  pageNumberContracts: 1,
  filterContracts: {
    // IF WE OPEN  THE WEBPAGE DON'T SEARCH, UNLESS WE USE MARKET
    // initial: true,

    // ALL CONTRACT FILTERS
    // search: "",
    // market: "finance_us",
    active: true,
    played: false,
    bids: [0, 1e6],
    prize: [0, 1e6],
    dates: [today, threeMonthsFromToday],

    // SPECIFIC TO MARKET FILTERS
    contracts: [],
    param1: [],
    param2: [],
    param3: [],
    param4: [],

    cparam0: "",
    // param5: [],
  },

  // S3 Files
  eventFile: "",
  holdingsFile: "",
  researchFile: "",
  eventVerified: false,
  holdingsVerified: false,
  researchVerified: false,
  portfolio: 0,
};

const FilterContractsContext = createContext<FilterContractsContextInt>(initialState);

export function FilterContractsProvider({ children }: React.PropsWithChildren) {
  // const { products } = useProductsContext();
  const [state, dispatch] = useReducer(reducer, initialState);

  const updateContractDataCONTEXT = () => {
    dispatch({ type: UPDATE_CONTRACT_DATA });
  };

  const updateHomeContractsDataCONTEXT = () => {
    dispatch({ type: UPDATE_HOME_CONTRACTS_DATA });
  };

  const updateContractsDataCONTEXT = () => {
    dispatch({ type: UPDATE_CONTRACTS_DATA });
  };

  const updateTokenContractsCONTEXT = () => {
    dispatch({ type: UPDATE_FILTER_CONTRACTS_TOKEN });
  };

  const updatePageNumberContractsCONTEXT = (pageNumber: number) => {
    dispatch({ type: UPDATE_FILTER_CONTRACTS_PAGENUMBER, payload: pageNumber });
  };

  // @ts-expect-error
  const updateSortContractsCONTEXT = (e) => {
    const value = e.target.value;
    dispatch({ type: UPDATE_FILTER_CONTRACTS_SORT, payload: value });
  };

  // @ts-expect-error
  const updateFilterContractsCONTEXT = (e) => {
    // get name and value of filter
    const name = e.target.name;
    let value = e.target.value;

    // update filter
    // if (name === "search-input") {name = "text"; value = e.target.value}; // search
    // if (name === "initial") value = e.target.value; // start filtering
    // if (name === "market") value = e.target.value; // category
    if (name === "active") value = e.target.value; // end_date > now | end_date < now
    if (name === "played") value = e.target.value; // end_date > now | end_date < now
    if (name === "bids") value = e.target.value; // bids
    if (name === "prize") value = e.target.value; // values
    if (name === "dates") value = e.target.value; // dates

    if (name === "contracts") value = e.target.value; // contracts
    if (name === "param1") value = e.target.value; // symbols
    if (name === "param2") value = e.target.value; // sectors
    if (name === "param3") value = e.target.value; // industries
    if (name === "param4") value = e.target.value; // style
    // if (name === "param5") value = e.target.textContent;

    dispatch({ type: UPDATE_FILTER_CONTRACTS_OBJECT, payload: { name, value } });
  };

  const clearFilterContractsCONTEXT = () => {
    dispatch({ type: CLEAR_FILTER_CONTRACTS });
  };

  // S3 UPLOAD
  const updateEventFileCONTEXT = (signature: string, verified: boolean) => {
    dispatch({ type: UPDATE_EVENT_FILE, payload: { signature, verified } });
  };

  const updateHoldingsFileCONTEXT = (signature: string, verified: boolean) => {
    dispatch({ type: UPDATE_HOLDINGS_FILE, payload: { signature, verified } });
  };

  const updateResearchFileCONTEXT = (signature: string, verified: boolean) => {
    dispatch({ type: UPDATE_RESEARCH_FILE, payload: { signature, verified } });
  };

  const updatePortfolioCONTEXT = (portfolio: number) => {
    dispatch({ type: UPDATE_PORTFOLIO, payload: portfolio });
  };

  return (
    <FilterContractsContext.Provider
      value={{
        ...state,
        updateTokenContractsCONTEXT,
        updatePageNumberContractsCONTEXT,
        updateSortContractsCONTEXT,
        updateFilterContractsCONTEXT,
        clearFilterContractsCONTEXT,
        updateContractDataCONTEXT,
        updateContractsDataCONTEXT,

        updateEventFileCONTEXT,
        updateHoldingsFileCONTEXT,
        updateResearchFileCONTEXT,
        updatePortfolioCONTEXT,

        updateHomeContractsDataCONTEXT,
      }}
    >
      {children}
    </FilterContractsContext.Provider>
  );
}
// make sure use
export const useFilterContractsContext = () => useContext(FilterContractsContext);
